"use client"
import React from "react";
import EnhancedBlogCard from "./EnhancedBlogCard";

const BlogContent = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Latest Blog Posts</h2>
          <div className="h-1 w-20 bg-blue-600 mx-auto rounded"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 place-items-center">
          <EnhancedBlogCard
            author={'Deepsikha Purkayastha'}
            topic={'Content Writing'}
            title={'Why SEO Is Crucial for Content Writing Jobs in 2025'}
            brief={'Discover why SEO writing is essential for content writers in 2025. Learn about SEO copywriting skills, career opportunities, and how to master search engine optimization for better content visibility...'}
            imageUrl={'https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
            linkUrl={'/blog/seo-content-writing-2025'}
            date={'June 22, 2025'}
          />

          <EnhancedBlogCard
            author={'Moumita Mandal'}
            topic={'Content Writing'}
            title={'How Digital Marketing Helps a Content Writer to Glow'}
            brief={'Discover how digital marketing skills can transform your content writing career, helping you reach the right audience, increase your value to employers, and build your personal brand...'}
            imageUrl={'https://images.unsplash.com/photo-1499750310107-5fef28a66643?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
            linkUrl={'/blog/content-writing/how-digital-marketing-helps-content-writers'}
            date={'May 16, 2025'}
          />

          <EnhancedBlogCard
            author={'Dipen Ghanty'}
            topic={'Job Search'}
            title={'Top 35 Job Portals to Simplify Your Job Search in 2025'}
            brief={'Looking for a job in India or abroad? Discover 35 of the best job portals to fast-track your job hunt in 2025, from Naukri and LinkedIn to Upwork and FlexJobs...'}
            imageUrl={'https://cdn.pixabay.com/photo/2017/10/31/09/55/dream-job-2904780_960_720.jpg'}
            linkUrl={'/blog/job-search/top-35-job-portals'}
            date={'June 18, 2025'}
          />

          <EnhancedBlogCard
            author={'Anurupa Kahali'}
            topic={'Digital Marketing'}
            title={'Why Digital Marketing in Kolkata is Booming: Opportunities, Career Scope & Services'}
            brief={'Explore why digital marketing in Kolkata is gaining rapid momentum. Learn about SEO, SMM, Google Ads, and career opportunities in the city\'s thriving digital industry...'}
            imageUrl={'https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
            linkUrl={'/blog/digital-marketing/why-digital-marketing-in-kolkata-is-booming'}
            date={'May 16, 2025'}
          />

          <EnhancedBlogCard
            author={'Tushar De'}
            topic={'Web Development'}
            title={'The Future of React.js Development in 2025 and Beyond'}
            brief={'Explore the future of React.js, upcoming features like Server Components, Concurrent Rendering, and how React continues to evolve...'}
            imageUrl={'https://images.unsplash.com/photo-1633356122102-3fe601e05bd2?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
            linkUrl={'/blog/web-development/future-of-reactjs-development'}
            date={'May 3, 2025'}
          />

          <EnhancedBlogCard
            author={'Tushar De'}
            topic={'AI & ML'}
            title={'Top AI & ML Trends to Watch in 2025'}
            brief={'Discover the most important artificial intelligence and machine learning trends shaping 2025, from multimodal AI to specialized models...'}
            imageUrl={'https://cdn.pixabay.com/photo/2024/01/29/22/47/ai-generated-8540913_1280.jpg'}
            linkUrl={'/blog/ai-ml/top-ai-ml-trends-to-watch'}
            date={'May 3, 2025'}
          />

          <EnhancedBlogCard
            author={'Tushar De'}
            topic={'Digital Marketing'}
            title={'Effective SEO Strategies for 2025: What Actually Works'}
            brief={'Learn about the most effective SEO strategies for 2025, including AI content optimization, E-E-A-T principles, and more...'}
            imageUrl={'https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
            linkUrl={'/blog/digital-marketing/seo-strategies-for-2024'}
            date={'May 3, 2025'}
          />

          <EnhancedBlogCard
            author={'Tushar De'}
            topic={'Cybersecurity'}
            title={'Emerging Cybersecurity Threats in 2025: What Organizations Need to Know'}
            brief={'Explore the most critical cybersecurity threats of 2025, from AI-powered attacks to quantum computing risks and defense strategies...'}
            imageUrl={'https://images.unsplash.com/photo-1592424002053-21f369ad7fdb?q=80&w=2574&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
            linkUrl={'/blog/cybersecurity/emerging-cybersecurity-threats-2025'}
            date={'May 15, 2025'}
          />

          <EnhancedBlogCard
            author={'Tushar De'}
            topic={'Business'}
            title={'The Future of Remote Work in 2025: How Distributed Models Are Reshaping Organizations'}
            brief={'Explore how remote and hybrid work has evolved into mature models reshaping organizations, careers, and the global economy...'}
            imageUrl={'https://images.unsplash.com/photo-1583508915901-b5f84c1dcde1?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
            linkUrl={'/blog/business/future-of-remote-work-2025'}
            date={'May 18, 2025'}
          />

          <EnhancedBlogCard
            author={'Tushar De'}
            topic={'Blockchain'}
            title={'Cryptocurrency & Blockchain Trends in 2025: The Maturing Landscape'}
            brief={'Explore the most significant blockchain and cryptocurrency developments in 2025, from mainstream financial integration to specialized blockchain ecosystems...'}
            imageUrl={'https://images.unsplash.com/photo-1639322537504-6427a16b0a28?q=80&w=2832&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
            linkUrl={'/blog/blockchain/cryptocurrency-blockchain-trends-2025'}
            date={'May 22, 2025'}
          />
        </div>
      </div>
    </div>
  );
};

export default BlogContent;
